
    import '/opt/buildhome/repo/packages/x/components/actions/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["actions-demo-basic","actions-demo-sub","actions-demo-preset","actions-demo-variant","actions-demo-fadein","actions-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/actions/index.zh-CN.md?type=demo')
};